import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import {
  SERVICES_CONTANTS,
  SERVICE_LIST_IDS,
  SERVICE_FILTERS,
  SERVICE_STATES
} from "@/modules/Services/constants/ServicesConstants";
import { ServiceTemplateHeader } from "@/modules/ServiceTemplate/models/ServiceTemplateHeader";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Utils } from "@/shared/utils/utils";
import lodash from "lodash";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { Http } from "@status/codes";
import { QuerySend, QuerySendMultiple } from "@/shared/models/FormQuerySend";
import Vuetify from "vuetify";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { ServiceTemplateModel } from "@/modules/ServiceTemplate/models/ServiceTemplateModel";
import { SectionGroup } from "@/modules/ServiceTemplate/models/SectionGroup";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import {
  SectionGroupDetail,
  SectionGroupDetailShort
} from "@/modules/ServiceTemplate/models/SectionGroupDetail";
import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { SectionGroupData } from "@/modules/MedicalOrder/models/SectionGroupData";
import { Service } from "@/modules/Services/models/Service";
import {
  GENERAL_RULES_CONSTANTS,
  RULES_COLLECTIONS,
  SERVICE_FIELDS,
  TASK_FORM_LABELS
} from "../../constants/GeneralRulesConstants";
import { ActionGeneralRules } from "../../models/actions.model";
import {
  SERVICE_TEMPLATES_ACCESS,
  SERVICE_TEMP_CONSTANTS
} from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { CUPS_ACCESS } from "@/modules/CupsPriceLevels/constants/CupsPriceLevelConstants";
import { ServiceActionForm } from "../../models/serviceActionForm.model";
import { ListService } from "@/modules/List/services/ListService";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { ArrayByKeys } from "@/shared/models/ArrayByKeys";
import { ConditionGeneralRules } from "../../models/condition.model";

Vue.use(Vuetify);

@Component({
  name: "AssignServiceActionModal",
  components: { GenericSearchBar, ModalTemplate }
})
export default class AssignServiceActionModal extends Vue {
  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() listService!: ListService;

  @Prop({ default: false }) private dialog!: boolean;
  @Prop() actionToEdit!: ActionGeneralRules;
  @Prop() editService!: boolean;
  @Prop() conditions!: ConditionGeneralRules[];

  cardClass = STYLE_CLASSES.CARD;
  TITLE_TEXT = SERVICES_CONTANTS.BUTTON.ASSIGN_SERVICE;
  HELP_TEXT = SERVICES_CONTANTS.HELP_TEXT;
  SEARCH_TEXT = FORM_CONSTANTS.BUTTON.SEARCH;
  ASSIGN_TEXT = SERVICES_CONTANTS.LABEL.ASSIGN_PRICE_LEVEL;
  TASK_FORM_LABELS = TASK_FORM_LABELS;
  filterArray: Filter[] = lodash.cloneDeep(SERVICE_FILTERS) as Filter[];
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryButtonClass = STYLE_CLASSES.SECONDARY_BTN;
  rowForms = STYLE_CLASSES.ROW_FORMS;
  loadingData = false;
  modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
  modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
  serviceTemplates: ServiceTemplateHeader[] = [];
  groupSections: SectionGroup[] | undefined = [];
  GROUP_TYPE = GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TYPE;
  SAVE_BUTTON = FORM_CONSTANTS.BUTTON.SAVE;
  CLOSE_BUTTON = FORM_CONSTANTS.BUTTON.CLOSE;
  SECTION_TEXT = GENERAL_CONSTANTS.SERVICE_TYPES.SECTION_TEXT;
  SECTIONS_TEXT = SERVICE_TEMP_CONSTANTS.TITLE.SECTION;
  SELECT_CUPS = SERVICES_CONTANTS.LABEL.CUPS_FIELD;
  GROUP_TEXT = GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TEXT;
  GROUPS_TEXT = SERVICE_TEMP_CONSTANTS.TITLE.GROUPS;
  STATE_TEXT = SERVICES_CONTANTS.LABEL.STATE;
  CATEGORY_TEXT = SERVICES_CONTANTS.LABEL.CATEGORY;
  TYPE_TEXT = SERVICES_CONTANTS.LABEL.TYPE;
  CUPS_TEXT = SERVICES_CONTANTS.LABEL.CUPS;
  DESC_TEXT = SERVICES_CONTANTS.LABEL.DESCRIPTION;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  SELECT_PRICE_LVL = SERVICES_CONTANTS.LABEL.SELECT_PRICE_LEVEL;
  CONTRACT_TYPE = SERVICES_CONTANTS.LABEL.CONTRACT_TYPE;
  CHARGE_CONCEPT = SERVICES_CONTANTS.LABEL.CHARGE_CONCEPT;
  ATTENTION_TYPE = SERVICES_CONTANTS.LABEL.ATTENTION_TYPE;
  USER_TYPE = SERVICES_CONTANTS.LABEL.USER_TYPE;
  assignTypes = GENERAL_CONSTANTS.ASSIGN_TYPES_LIST;
  ASSIGN_SERVICE_LABEL = SERVICES_CONTANTS.LABEL.ASSIGN_SERVICE;
  PERSONALIZED = SERVICES_CONTANTS.LABEL.PERSONALIZED_STATE;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  SELECTED_CHIP = STYLE_CLASSES.CHIP_COLOR.SELECTED;
  serviceTempType = "";
  currentItems: SectionGroupDetail[] = [];
  sessionsFormTemps: SectionGroupDetail[] = [];
  cups = "";
  groupSectionAssignType = "";
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  dialogAccept = false;
  filterItems: QuerySendMultiple = {};
  lastServiceRef = "";
  priceLevelKey = 0;
  firstserviceAssignTypeChange = true;
  searched = false;
  requiredOrder = false;
  loadingSectionsOrGroups = false;
  groupSectionSelected: SectionGroup | string = "";
  serviceActionForm: ServiceActionForm = {
    step: 1,
    daysToApply: 0,
    price: "",
    cupsSelected: "",
    serviceAssignType: "",
    contractType: "",
    userType: "",
    attentionType: "",
    chargeConcept: "",
    serviceCups: [],
    priceLevels: [],
    serviceTemplate: new ServiceTemplateModel(),
    currentSectionGroups: [],
    savedItems: [],
    contractTypes: [],
    userTypes: [],
    attentionTypes: [],
    chargeConcepts: []
  };
  editComparationStr = "";
  invalidEdit = false;

  async mounted() {
    if (this.editService) this.preloadService(this.actionToEdit);
    this.filterArray[0].secondaryFilters[1].options = await Utils.getListAndMapItAsSecondaryFilterOptions(
      SERVICE_LIST_IDS.CATEGORY
    );
    this.getContractTypes();
    this.getUserTypes();
    this.getAttentionTypes();
    this.getChargeConcepts();
  }

  preloadService(actionToEdit: ActionGeneralRules) {
    if (!actionToEdit.assignService) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return;
    }
    this.invalidEdit = true;

    this.serviceActionForm.step = 3;
    this.serviceActionForm.daysToApply = actionToEdit.daysToApply;
    this.serviceActionForm.price = actionToEdit.assignService.priceLevel;
    this.serviceActionForm.cupsSelected = actionToEdit.assignService.cups;
    this.serviceActionForm.contractType =
      actionToEdit.assignService.contractType;
    this.serviceActionForm.userType = actionToEdit.assignService.userType;
    this.serviceActionForm.attentionType =
      actionToEdit.assignService.attentionType;
    this.serviceActionForm.chargeConcept =
      actionToEdit.assignService.chargeConcept;
    if (
      (actionToEdit.assignService.groups &&
        actionToEdit.assignService.groups.length === 0) ||
      (actionToEdit.assignService.sections &&
        actionToEdit.assignService.sections.length === 0)
    ) {
      this.serviceActionForm.serviceAssignType =
        GENERAL_CONSTANTS.ASSIGN_TYPES_LIST[0];
    } else {
      this.serviceActionForm.serviceAssignType =
        GENERAL_CONSTANTS.ASSIGN_TYPES_LIST[1];
    }
    this.getServiceTemplate(
      actionToEdit.assignService.serviceTemplate,
      false,
      actionToEdit.assignService
    );
  }

  get assignGroupSectionLabel(): string {
    if (this.serviceActionForm.serviceTemplate.type == this.GROUP_TYPE)
      return SERVICES_CONTANTS.LABEL.ASSIGN_GROUP;
    else return SERVICES_CONTANTS.LABEL.ASSIGN_SECTION;
  }

  get sessionsFormTempLabel(): string {
    if (this.serviceActionForm.serviceTemplate.type == this.GROUP_TYPE)
      return SERVICES_CONTANTS.LABEL.SESSIONS;
    else return SERVICES_CONTANTS.LABEL.FORM_TEMPS;
  }

  async getServiceFilterEvents(data: any) {
    delete data["mainFilterKey"];
    this.filterItems = { ...data };
    this.lastServiceRef = "";
    await this.searchData(data, false);
  }

  async searchData(
    filterQueryService: QuerySendMultiple,
    shouldPaginate?: boolean
  ) {
    if (!shouldPaginate) this.loadingData = true;

    const filterQuery: QuerySend = {
      state: FORM_CONSTANTS.STATE.ACTIVE,
      paginatedResult: true
    };

    try {
      if (filterQueryService.name)
        filterQuery.internalName = filterQueryService.name[0];

      if (filterQueryService.type)
        filterQuery.type = filterQueryService.type[0];

      if (filterQueryService.category)
        filterQuery.category = filterQueryService.category[0];

      if (this.lastServiceRef) filterQuery.docref = this.lastServiceRef;

      const response = await this.serviceTemplateService.getServiceTemplateWithFilters(
        { ...filterQuery, requiredPriorOrder: false }
      );

      if (response.code === Http.Found && response.data) {
        const serviceList = response.data.serviceTemplates;
        this.lastServiceRef = response.data.docref;
        if (shouldPaginate) {
          this.serviceTemplates = [...this.serviceTemplates, ...serviceList];
        } else {
          this.serviceTemplates = serviceList;
        }
      } else {
        if (!shouldPaginate) {
          this.serviceTemplates = [];
        }
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      return Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }

    this.loadingData = false;
  }

  async getServiceTemplate(
    id: string,
    isSearching: boolean,
    actionToEdit?: Service
  ) {
    try {
      this.loadingData = true;
      if (isSearching) {
        this.serviceActionForm.price = "";
        this.priceLevelKey++;
        this.cleanServiceConfig();
        this.searched = isSearching;
        if (this.editService) {
          this.serviceActionForm.cupsSelected = "";
          this.cups = "";
        }
      }

      if (
        (actionToEdit &&
          actionToEdit.sections &&
          actionToEdit?.sections.length === 0) ||
        (actionToEdit &&
          actionToEdit?.groups &&
          actionToEdit?.groups.length === 0) ||
        isSearching
      ) {
        const response = await this.serviceTemplateService.getServiceTemplateByIdBasicInfo(
          id
        );

        if (response.code == Http.Found && response.data) {
          this.serviceActionForm.serviceTemplate = response.data;
          if (
            await this.isSameServiceOfCondition(
              this.serviceActionForm.serviceTemplate.id as string
            )
          ) {
            this.loadingData = false;
            Snackbar.popError(
              GENERAL_RULES_CONSTANTS.MESSAGES
                .NOT_ASSIGN_SAME_SERVICE_OF_CONDITION
            );
            return;
          }
          this.serviceActionForm.step = 3;
          if (this.serviceActionForm.serviceTemplate.type == this.GROUP_TYPE) {
            const groupsArray = response.data.groups ?? [];
            const arrayCups: string[] = [];
            for (const iterator of groupsArray) {
              arrayCups.push(iterator.cups as string);
            }
            await this.getCupsByService(arrayCups);
          } else {
            this.serviceActionForm.cupsSelected =
              this.serviceActionForm.serviceTemplate.cups ?? "";
          }
          if (this.serviceActionForm.cupsSelected) {
            await this.getPriceLevelsByCup(
              this.serviceActionForm.cupsSelected as string
            );
          }
          this.loadingData = false;
          return;
        }
        this.loadingData = false;
        Snackbar.popError(response.message);
        return;
      }

      this.loadingSectionsOrGroups = true;

      const response = await this.serviceTemplateService.getServiceTemplateById(
        id
      );

      if (response.code == Http.Found && response.data) {
        this.serviceActionForm.serviceTemplate = response.data;
        this.serviceActionForm.step = 3;

        if (response.data.type === this.GROUP_TYPE) {
          this.groupSections = this.preloadGroupsSections(
            response.data.groups,
            actionToEdit
          );
          this.serviceTempType = this.GROUP_TEXT;
        } else {
          this.groupSections = this.preloadGroupsSections(
            response.data.sections,
            actionToEdit
          );
          this.serviceTempType = this.SECTION_TEXT;
        }

        this.serviceActionForm.currentSectionGroups = this
          .groupSections as SectionGroup[];
        this.fillSavedItems();
        if (this.serviceActionForm.serviceTemplate.type == this.GROUP_TYPE) {
          const arrayCups: string[] = [];
          for (const iterator of this.serviceActionForm.currentSectionGroups) {
            arrayCups.push(iterator.cups as string);
          }
          await this.getCupsByService(arrayCups);
        } else {
          this.serviceActionForm.cupsSelected =
            this.serviceActionForm.serviceTemplate.cups ?? "";
        }
        if (this.serviceActionForm.cupsSelected) {
          await this.getPriceLevelsByCup(
            this.serviceActionForm.cupsSelected as string
          );
        }
        this.loadingSectionsOrGroups = false;
        this.loadingData = false;
        this.editComparationStr = JSON.stringify(this.serviceActionForm);
        return;
      }

      Snackbar.popError(response.message);
      this.loadingSectionsOrGroups = false;
      this.loadingData = false;
      return;
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  @Watch("serviceActionForm", { deep: true })
  checkEdit() {
    if (this.editService && !this.loadingData) {
      this.invalidEdit =
        JSON.stringify(this.serviceActionForm) === this.editComparationStr;
    }
  }
  @Watch("serviceActionForm.cupsSelected")
  async onSelectCups() {
    if (
      this.serviceActionForm.serviceTemplate.type == this.GROUP_TYPE &&
      this.serviceActionForm.cupsSelected
    ) {
      await this.getPriceLevelsByCup(this.serviceActionForm.cupsSelected);
    }
  }

  async getCupsByService(arrayOfCups: string[]) {
    try {
      this.serviceActionForm.serviceCups = [];
      for (const cupsId of arrayOfCups) {
        const responseData = await this.cupsPriceLevelService.getCupsPriceLevelById(
          cupsId
        );
        if (
          responseData.code === Http.Found &&
          responseData.data !== undefined
        ) {
          this.serviceActionForm.serviceCups.push({
            key: responseData.data.id as string,
            name: responseData.data.externalName
          });
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICE_TEMPLATES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getPriceLevelsByCup(cups: string) {
    try {
      const priceLevels = await this.cupsPriceLevelService.getCupsPriceLevelById(
        cups
      );

      if (priceLevels.code === Http.Found && priceLevels.data) {
        this.cups = priceLevels.data.cups ?? "";
        this.serviceActionForm.priceLevels = Utils.getArrayByKeys(
          priceLevels.data.clients,
          SERVICES_CONTANTS.ATTRIBUTES
        );
      } else {
        this.cups = "";
        this.serviceActionForm.priceLevels = [];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getServiceTempleteWithSectionsOrGroups(id: string) {
    try {
      const response = await this.serviceTemplateService.getServiceTemplateById(
        id
      );

      if (response.code == Http.Found && response.data) {
        this.serviceActionForm.serviceTemplate = response.data;
        this.serviceActionForm.step = 3;
        this.groupSections =
          response.data.type === this.GROUP_TYPE
            ? response.data.groups
            : response.data.sections;
        this.serviceTempType =
          response.data.type === this.GROUP_TYPE
            ? this.GROUP_TEXT
            : this.SECTION_TEXT;
        this.serviceActionForm.currentSectionGroups = this.groupSections?.slice() as SectionGroup[];
        this.fillSavedItems();
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${CUPS_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  preloadGroupsSections(
    sectionGroup: SectionGroup[] | undefined,
    actionToEdit: Service | undefined
  ): SectionGroup[] | undefined {
    if (!actionToEdit) {
      return sectionGroup;
    }

    const sectionOrGroup = actionToEdit.groups
      ? actionToEdit.groups.map((item: SectionGroupData) => ({
          key: item.key,
          sessions: item.sessions
        }))
      : actionToEdit.sections!.map((item: SectionGroupData) => {
          return {
            key: item.key,
            formTemplates: (item.formTemplates as SectionGroupDetailShort[])!.map(
              (element: SectionGroupDetailShort) => element.id
            )
          };
        });

    const sectionsGroupItemsFiltered = (JSON.parse(
      JSON.stringify(sectionGroup)
    ) as SectionGroup[]).filter(element => {
      return (sectionOrGroup as SectionGroupData[]).find(
        (item: any) => element.key === item.key
      );
    });

    return sectionsGroupItemsFiltered.map((item, index) => {
      if (actionToEdit.type === this.GROUP_TYPE) {
        item.sessions = (item.sessions as SectionGroupDetail[]).filter(
          (element: SectionGroupDetail) => {
            return (sectionOrGroup[
              index
            ] as SectionGroupData)!.sessions!.includes(element.id);
          }
        );
      } else {
        item.formTemplates = (item.formTemplates as SectionGroupDetail[]).filter(
          (element: SectionGroupDetail) => {
            return ((sectionOrGroup[index] as SectionGroupData)!
              .formTemplates as string[])!.includes(element.id);
          }
        );
      }

      return item;
    });
  }

  fillSavedItems() {
    this.serviceActionForm.currentSectionGroups.forEach(item => {
      this.serviceActionForm.savedItems.push({
        key: item.key,
        type: GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED,
        selected:
          this.serviceTempType === GENERAL_CONSTANTS.SERVICE_TYPES.GROUP_TEXT
            ? (item.sessions as SectionGroupDetail[])
            : (item.formTemplates as SectionGroupDetail[])
      });
    });
  }

  cleanServiceConfig() {
    this.groupSectionSelected = "";
    this.groupSections = [];
    this.sessionsFormTemps = [];
    this.serviceActionForm.currentSectionGroups = [];
    this.currentItems = [];
    this.serviceActionForm.savedItems = [];
    this.serviceActionForm.serviceAssignType = "";
    this.groupSectionAssignType = "";
  }

  onTagSelected(id: string) {
    this.groupSectionSelected =
      this.serviceActionForm.currentSectionGroups.find(i => i.key === id) ?? "";
  }

  onTagClosed(index: number) {
    this.serviceActionForm.currentSectionGroups.splice(index, 1);
    this.serviceActionForm.savedItems.splice(index, 1);
    this.groupSectionSelected = "";
    this.groupSectionAssignType = "";
    this.currentItems = [];
  }

  setSectionGroup() {
    if (this.groupSectionAssignType === "")
      return Snackbar.popInfo(
        this.serviceActionForm.serviceTemplate.type === this.GROUP_TYPE
          ? SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_GROUP
          : SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_SECTION
      );
    if (
      this.groupSectionAssignType ===
        GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED &&
      this.currentItems.length === 0
    )
      return Snackbar.popInfo(
        this.serviceActionForm.serviceTemplate.type === this.GROUP_TYPE
          ? SERVICES_CONTANTS.MESSAGE.SELECT_SESSIONS
          : SERVICES_CONTANTS.MESSAGE.SELECT_FORM_TEMPS
      );

    if (
      !this.serviceActionForm.currentSectionGroups.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )
    ) {
      this.serviceActionForm.currentSectionGroups.push(
        this.groupSectionSelected as SectionGroup
      );
    }

    const valueExist = this.serviceActionForm.savedItems.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );

    if (valueExist) {
      valueExist.selected =
        this.groupSectionAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE
          ? []
          : [...this.currentItems];
      valueExist.type = this.groupSectionAssignType;
    } else {
      this.serviceActionForm.savedItems.push({
        key: (this.groupSectionSelected as SectionGroup).key,
        selected:
          this.groupSectionAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.COMPLETE
            ? []
            : [...this.currentItems],
        type: this.groupSectionAssignType
      });
    }

    this.currentItems = [];
    this.groupSectionSelected = "";
    this.groupSectionAssignType = "";
  }

  async handleSectionsChange(serviceAssignType: string) {
    if (serviceAssignType !== GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED) return;

    if (
      this.editService &&
      serviceAssignType === GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED &&
      this.groupSections &&
      this.groupSections.length > 0
    )
      return;

    this.loadingSectionsOrGroups = true;
    await this.getServiceTempleteWithSectionsOrGroups(
      this.serviceActionForm.serviceTemplate.id as string
    );
    this.loadingSectionsOrGroups = false;
  }

  async assignService() {
    if (!this.serviceActionForm.serviceAssignType)
      Snackbar.popWarning(SERVICES_CONTANTS.MESSAGE.SELECT_ASSIGN_SERVICE);
    else this.dialogAccept = this.serviceBillingValidation();
  }

  serviceBillingValidation(): boolean {
    if (this.serviceActionForm.serviceTemplate.id) return true;
    Snackbar.popError(SERVICES_CONTANTS.MESSAGE.NO_ID);
    return false;
  }

  close() {
    this.serviceActionForm.step = 1;
    this.serviceActionForm.price = "";
    this.$emit(GENERAL_CONSTANTS.V_ON_EVENTS.CLOSE_ASSIGN_SERVICE);
  }

  async handleModalAccept() {
    this.dialogAccept = false;
    let convertedData: SectionGroupData[] = [];

    if (
      this.serviceActionForm.serviceAssignType ===
      GENERAL_CONSTANTS.ASSIGN_TYPE.CUSTOMIZED
    )
      convertedData = this.convertSectionGroups();

    try {
      const serviceToAssing: Service = {
        internalName: this.serviceActionForm.serviceTemplate.internalName,
        category: this.serviceActionForm.serviceTemplate.category,
        cups: this.serviceActionForm.cupsSelected || "",
        type: this.serviceActionForm.serviceTemplate.type,
        priceLevel: this.serviceActionForm.price,
        contractType: this.serviceActionForm.contractType,
        userType: this.serviceActionForm.userType,
        attentionType: this.serviceActionForm.attentionType,
        chargeConcept: this.serviceActionForm.chargeConcept,
        user: "",
        serviceTemplate: this.serviceActionForm.serviceTemplate.id || "",
        progress: 0,
        carer: "",
        attendedBy: "",
        medicalOrder: "",
        state: SERVICE_STATES.NOT_ASSIGNED
      };

      if (this.serviceActionForm.serviceTemplate.type === this.GROUP_TYPE) {
        serviceToAssing.groups = convertedData;
        serviceToAssing.groupsFilled = {};
        serviceToAssing.sessionsFilled = {};
      } else {
        serviceToAssing.sections = convertedData;
        serviceToAssing.sectionsFilled = {};
        serviceToAssing.formTemplatesFilled = {};
      }

      this.$emit(
        GENERAL_CONSTANTS.V_ON_EVENTS.SERVICE_TO_ASSIGN,
        serviceToAssing,
        this.serviceActionForm.daysToApply
      );
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  convertSectionGroups(): SectionGroupData[] {
    const data: SectionGroupData[] = [];

    if (this.serviceActionForm.serviceTemplate.type === this.GROUP_TYPE) {
      this.serviceActionForm.savedItems.forEach(s => {
        data.push({
          key: s.key,
          sessions: s.selected.map(i => i.id)
        });
      });
    } else {
      this.serviceActionForm.savedItems.forEach(section => {
        data.push({
          key: section.key,
          formTemplates: section.selected.map(item => ({
            id: item.id,
            multiple: item.multiple ? item.multiple : false
          }))
        });
      });
    }

    return data;
  }

  @Watch("groupSectionSelected")
  getFormSessions() {
    if (this.serviceActionForm.serviceTemplate.type === this.GROUP_TYPE) {
      this.sessionsFormTemps = this.serviceActionForm.serviceTemplate.groups?.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )?.sessions as SectionGroupDetail[];
    } else {
      this.sessionsFormTemps = this.serviceActionForm.serviceTemplate.sections?.find(
        i => i.key === (this.groupSectionSelected as SectionGroup).key
      )?.formTemplates as SectionGroupDetail[];
    }

    const existGroup = this.serviceActionForm.currentSectionGroups.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );

    const dataSelected = this.serviceActionForm.savedItems.find(
      i => i.key === (this.groupSectionSelected as SectionGroup).key
    );

    if (existGroup && dataSelected) {
      this.groupSectionAssignType = dataSelected.type.slice();
      this.currentItems = [...dataSelected.selected];
    } else {
      this.groupSectionAssignType = "";
      this.currentItems = [];
    }
  }

  handleModalCancel() {
    this.dialogAccept = false;
  }

  @Watch("serviceActionForm.serviceAssignType")
  listenServiceAssignType() {
    if (
      this.serviceActionForm.serviceAssignType !== this.PERSONALIZED ||
      this.firstserviceAssignTypeChange
    ) {
      this.firstserviceAssignTypeChange = false;
      return;
    }

    this.getServiceTemplate(this.serviceActionForm.serviceTemplate.id!, false);
  }

  async onBottomServiceScroll(e: any) {
    const { scrollTop, offsetHeight, scrollHeight } = e.target;
    if (scrollTop + offsetHeight >= scrollHeight - 1) {
      await this.searchData(this.filterItems, true);
    }
  }

  async getContractTypes() {
    this.serviceActionForm.contractTypes = await this.getListById(
      SERVICE_LIST_IDS.CONTRACT_TYPE
    );
  }
  async getUserTypes() {
    this.serviceActionForm.userTypes = await this.getListById(
      SERVICE_LIST_IDS.USER_TYPE
    );
  }
  async getAttentionTypes() {
    this.serviceActionForm.attentionTypes = await this.getListById(
      SERVICE_LIST_IDS.ATTENTION_TYPE
    );
  }
  async getChargeConcepts() {
    this.serviceActionForm.chargeConcepts = await this.getListById(
      SERVICE_LIST_IDS.CHARGE_CONCEPT
    );
  }

  async getListById(id: string): Promise<ArrayByKeys[]> {
    try {
      const responseData = await this.listService.getListById(id);

      if (responseData.code === Http.Found && responseData.data) {
        const dataList = responseData.data.optionsSchema;
        return dataList.map(data => {
          return { key: data.const, name: data.title };
        });
      }
      return [];
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return [];
    }
  }

  async isSameServiceOfCondition(serviceTemplateId: string) {
    const serviceFieldsInConditions = GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES.find(
      e => e.key == RULES_COLLECTIONS.SERVICES
    )?.fields;
    const serviceTempConditionField = serviceFieldsInConditions?.find(
      e => e.key == SERVICE_FIELDS.TEMPLATE
    )?.field;
    const stateConditionField = serviceFieldsInConditions?.find(
      e => e.key == SERVICE_FIELDS.STATE
    )?.field;
    const valueOfserviceTemp = this.conditions.find(
      e => e.key == serviceTempConditionField
    )?.value[0].key;
    const valueOfState = this.conditions.find(e => e.key == stateConditionField)
      ?.value[0].key;
    return (
      valueOfserviceTemp == serviceTemplateId &&
      valueOfState == SERVICE_STATES.NOT_ASSIGNED
    );
  }
}
